// src/components/LazyVideo.js

import React, { useRef, useState, useEffect } from 'react';

const LazyVideo = ({ src, type, ...props }) => {
  const videoRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(videoRef.current);
      }
    };
  }, [videoRef]);

  return (
    <video
      ref={videoRef}
      autoPlay={inView}
      loop
      muted
      {...props}
      className="h-full w-full object-cover rounded-lg"
    >
      {inView && <source src={src} type={type} />}
      Your browser does not support the video tag.
    </video>
  );
};

export default LazyVideo;
